var VCA = VCA || {};


VCA.HospitalActionPanel = (function ($) {

    var ui = {};

    function init() {
        if ($('.hospital-action-panel').length <= 0) {
            return;
        }
        bindGalleryClick();
        bindGalleryCloseClick();
    }

    function bindGalleryClick() {
        $('.js-open-gallery-modal').on('click', function (e) {
            e.preventDefault();
            $('#gallery-modal .js-article-image-slider').css("visibility", "hidden");
            $('#gallery-modal').modal('show');
            $('#gallery-modal').on('shown.bs.modal', function (e) {
                window.dispatchEvent(new Event('resize'));
                $('#gallery-modal .js-article-image-slider').css("visibility", "visible");
            });
        });
    }

    function bindGalleryCloseClick() {
        $('.vca-modal__close').on('click', function (e) {
            var vimeoPlayerIFrame = $('#modal-carousel-vimeo-iframe');
            if (vimeoPlayerIFrame && vimeoPlayerIFrame.length > 0) {
                Array.from(vimeoPlayerIFrame).forEach((vimeoPlayerIFrameElement) => {
                    var vimeoPlayer = new Vimeo.Player(vimeoPlayerIFrameElement);
                    if (vimeoPlayer) {
                        vimeoPlayer.unload();
                    }
                });
            }
        });
    }
    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.HospitalActionPanel.init();
});